import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { BillingUi } from '@/lib/portalBilling';

/** The Billing tab body: a pay card while an invoice is outstanding, a
 *  thank-you card once paid. The parent only mounts this when
 *  `billingUi(...).showBillingTab` is true, so the fallback branch
 *  (link not set yet) is the practitioner-forgot-the-link edge, not the
 *  common path. */
export function PortalBilling({
  ui,
  paymentUrl,
}: {
  ui: BillingUi;
  paymentUrl: string | null | undefined;
}) {
  if (ui.paid) {
    return (
      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle>Paid - thank you</CardTitle>
          <CardDescription>
            Your invoice is settled and your report exports are unlocked on the Report tab.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card className="max-w-2xl">
      <CardHeader>
        <CardTitle>Pay your invoice</CardTitle>
        <CardDescription>
          Your engagement invoice is ready. Paying it unlocks the report exports (PDF and CSV) on
          the Report tab.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {paymentUrl ? (
          <Button asChild type="button">
            <a href={paymentUrl} target="_blank" rel="noopener noreferrer">
              Pay invoice
            </a>
          </Button>
        ) : (
          <p className="text-sm text-brand-slate">
            Your payment link is being prepared. Reach out to your InputRecovery contact if this
            persists.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
